import { useState, useRef, useEffect } from "react";
import {
  ContainerTimePicker,
  InputTimeContainer,
} from "./TimeComponentStyles.styled";

export const TimePickerComponent = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (val: string) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const [selectedHour, setSelectedHour] = useState("00");
  const [selectedMinute, setSelectedMinute] = useState("00");

  // ⬅️ ОНОВЛЕННЯ ПРИ ЗМІНІ value
  useEffect(() => {
    if (!value) {
      // якщо value ще не передано
      const now = new Date();
      const h = String(now.getHours()).padStart(2, "0");
      const m = String(now.getMinutes()).padStart(2, "0");
      setSelectedHour(h);
      setSelectedMinute(m);
      onChange(`${h}:${m}`); // щоб батьківський компонент теж отримав час
    }
  }, [value, onChange]);

  // Закриття при натисканні назовні
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const selectTime = (h: string, m: string) => {
    const t = `${h}:${m}`;
    onChange(t);
    setIsOpen(false);
  };

  return (
    <ContainerTimePicker ref={containerRef}>
      <InputTimeContainer
        type="text"
        readOnly
        value={`${selectedHour}:${selectedMinute}`}
        onClick={() => setIsOpen(!isOpen)}
      />

      {isOpen && (
        <div
          style={{
            position: "absolute",
            background: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
            zIndex: 2,
            display: "flex",
            gap: "10px",
          }}
        >
          <div style={{ maxHeight: "150px", overflowY: "scroll" }}>
            {hours.map((h) => (
              <div
                key={h}
                style={{ padding: "5px", cursor: "pointer" }}
                onClick={() => {
                  setSelectedHour(h);
                  selectTime(h, selectedMinute);
                }}
              >
                {h}
              </div>
            ))}
          </div>

          <div style={{ maxHeight: "150px", overflowY: "scroll" }}>
            {minutes.map((m) => (
              <div
                key={m}
                style={{ padding: "5px", cursor: "pointer" }}
                onClick={() => {
                  setSelectedMinute(m);
                  selectTime(selectedHour, m);
                }}
              >
                {m}
              </div>
            ))}
          </div>
        </div>
      )}
    </ContainerTimePicker>
  );
};
